//import $ from "jquery";

class Navigation {
  constructor() {
    //console.log("Navigation/Constructor");

    this.scroll = false;

    var welcomeSecHeader = document.querySelectorAll(".welcome-sec__header");
    var skillsSecHeader = document.querySelectorAll(".skills-sec__header");
    var projectsSecHeader = document.querySelectorAll(".projects-sec__header");
    var learningSecHeader = document.querySelectorAll(".learning-sec__header");
    var contactSecHeader = document.querySelectorAll(".contact-sec__header");

    let items = {
      navtop: ["navtop", "#NavTopAll", 0],
      welcome: ["welcome", "#WelcomeAll", welcomeSecHeader[0].offsetTop],
      skills: ["skills", "#SkillsAll", skillsSecHeader[0].offsetTop],
      projects: ["projects", "#ProjectsAll", projectsSecHeader[0].offsetTop],
      learning: ["learning", "#LearningAll", learningSecHeader[0].offsetTop],
      contact: ["contact", "#ContactAll", contactSecHeader[0].offsetTop],
    };

    let i = 0;
    this.navObj = [];
    for (let item in items) {
      this.navObj[i] = document.querySelectorAll(items[item][1])[0]; // $(items[item][1])[0];
      i++;
    }
    this.events(items);
  }

  events(items) {
    // Each navigation items is bind to an event listener, which calls onClickPos when clicked
    //console.log("Navigation/make event", this.navObj);
    let i = 0;
    for (let item in items) {
      this.navObj[i].addEventListener("click", (e) => this.onClickPos(e, items));
      this.navObj[i].addEventListener("mouseover", () => this.onHover(items[item][0]));
      this.navObj[i].addEventListener("mouseout", () => this.onHoverOut(items[item][0]));
      i++;
    }

    // scroll Listener
    document.addEventListener("scroll", () => this.onStart());
  }

  onStart = () => {
    this.scroll = true;
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const rotation = (winScroll / height) * 360;

    //console.log("do scroll: ", winScroll, height, rotation);
    var wheelNav = document.getElementById("wheelNav");

    wheelNav.style.transform = `rotate(${rotation}deg)`;
    this.scroll = false;
  };

  onHover = (arg) => {
    //console.log("hover", arg, `#${arg[0].toUpperCase()}${arg.substring(1)}Txt`);
    var [hoverEl] = document.querySelectorAll(`#${arg[0].toUpperCase()}${arg.substring(1)}Txt`);
    hoverEl.classList.add("active");
  };

  onHoverOut = (arg) => {
    //console.log("hoverOut", arg);
    var [hoverOutEl] = document.querySelectorAll(`#${arg[0].toUpperCase()}${arg.substring(1)}Txt`);
    hoverOutEl.classList.remove("active");
  };

  onClickPos = (e, items) => {
    // nav item is extracted from clicked event
    // with that information the scroll information from items can be provided
    //console.log("Navigation/onClickPos", e, e.target.id, e.target.id.toLowerCase());
    let str = e.target.id.toLowerCase();
    str = str.slice(0, -3);

    window.scrollTo({
      left: 0,
      top: items[str][2],
      behavior: "smooth",
    });

    // trigger rotation of navbar
    this.onRotate(items[str][2]);
  };

  onRotate = (pos) => {
    if (!this.scroll) {
      const winScroll = pos; // || document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const rotation = (winScroll / height) * 360;

      //console.log("do rotate: ", pos, winScroll, height, rotation);

      //return rotation;
      //console.log(rotation, $("#wheelNav")[0].style);
      var wheelNav = document.querySelectorAll("#wheelNav");
      wheelNav[0].style = `transform: rotate(${rotation}deg); transition: all 0.5s linear`;
      //console.log(rotation, $("#wheelNav")[0].style);
    }
  };
}

export default Navigation;
